import { createContext, Dispatch } from 'react'
import { DomainNotificationTemplateProviderAction, DomainNotificationTemplateProviderState } from './types'

export const DomainNotificationTemplateProviderContext = createContext<{
    state: DomainNotificationTemplateProviderState
    dispatch: Dispatch<DomainNotificationTemplateProviderAction>
}>(null!)
